import type { SimCardStates } from '@racemap/sdk/schema/simCard';
import { RacemapAPIClient } from '@racemap/utilities/api-client';
import { usePaginatedList } from './usePaginatedList';

const apiClient = RacemapAPIClient.fromWindowLocation();

interface UseSimsParams {
  search?: string;
  userId?: string;
  state?: SimCardStates;
}

export function useSimCardsPaginated({ search, userId, state }: UseSimsParams) {
  const { items: sims, ...rest } = usePaginatedList(
    'SIMS',
    { search, userId, state },
    (params, page) => apiClient.listSims({ ...params, ...page }),
  );
  return { sims, ...rest };
}
